<template>
  <footer>
    <div class="planteta">
      <img class="top" src="../assets/images/planteta_top.png">
      <img class="bottom" src="../assets/images/planteta_bottom.png">
    </div>
    <div class="wrapper">
      <a class="instagram" href="https://www.instagram.com/kuki_project/" target="_blank">
        <img alt="instagram" src="../assets/images/instagram.png">
        <span>{{ $t("footer.instagram") }}</span>
      </a>
      <span>Kūki · {{ currentYear }}</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  props: {},
  computed: {
    currentYear: () => new Date().getFullYear()
  }
};
</script>

<style scoped>
footer {
  position: absolute;
  width: 100%;
}

footer .wrapper {
  color: #fff;
  background: #00c8b7;
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  align-items: center;
  font-size: 1em;
}

footer .wrapper a.instagram {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  padding: 0.4em 0;
  text-decoration: none;
  color: #fff;
}

footer .wrapper a.instagram img {
  max-width: 10%;
  margin-right: 0.4em;
}

footer .planteta {
  position: absolute;
  display: flex;
  flex-flow: column wrap;
  max-width: 50px;
  right: 10%;
  top: -44px;
}

@keyframes grow-position {
  from {
    top: -44;
  }
  to {
    top: -66px;
  }
}

@keyframes grow-size {
  from {
    height: 44px;
  }
  to {
    height: 66px;
  }
}

footer .planteta:hover {
  animation-name: grow-position;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
}

footer .planteta:hover .bottom {
  animation-name: grow-size;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
}

@media only screen and (max-width: 800px) {
  footer .wrapper {
    font-size: 1.7em;
  }
}
</style>
